<template lang='pug'>
div
  v-row
    v-col
      TextFieldNutrient(
        nutrient='carbohydrate'
        :nutrient_value_initial='initial_carbs'
        @update:nutrient_value='update_carbs'
        v-slot='{ focused_update, nutrient, nutrient_value, nutrient_value_update }'
      )
        v-text-field(
          autocomplete='off'
          type='number'
          :value='nutrient_value'
          @blur='focused_update(false)'
          @focus='focused_update(true)'
          @input='nutrient_value_update'
          outlined
        )
          template(
            v-slot:label
          )
            LabelNutrient(
              :nutrient='nutrient'
            )
      TextFieldNutrient(
        nutrient='fat'
        :nutrient_value_initial='initial_fat'
        @update:nutrient_value='update_fat'
        v-slot='{ focused_update, nutrient, nutrient_value, nutrient_value_update }'
      )
        v-text-field(
          autocomplete='off'
          type='number'
          :value='nutrient_value'
          @blur='focused_update(false)'
          @focus='focused_update(true)'
          @input='nutrient_value_update'
          outlined
        )
          template(
            v-slot:label
          )
            LabelNutrient(
              :nutrient='nutrient'
            )
      TextFieldNutrient(
        nutrient='protein'
        :nutrient_value_initial='initial_protein'
        @update:nutrient_value='update_protein'
        v-slot='{ focused_update, nutrient, nutrient_value, nutrient_value_update }'
      )
        v-text-field(
          autocomplete='off'
          type='number'
          :value='nutrient_value'
          @blur='focused_update(false)'
          @focus='focused_update(true)'
          @input='nutrient_value_update'
          outlined
        )
          template(
            v-slot:label
          )
            LabelNutrient(
              :nutrient='nutrient'
            )
    v-col
      TextFieldNutrient(
        nutrient='calories'
        :nutrient_value_initial='calories_carbs'
        @update:nutrient_value='nutrient_value => update_carbs(nutrient_value ? nutrient_value / 4 : nutrient_value)'
        v-slot='{ focused_update, nutrient, nutrient_value, nutrient_value_update }'
      )
        v-text-field(
          autocomplete='off'
          type='number'
          :value='nutrient_value'
          @blur='focused_update(false)'
          @focus='focused_update(true)'
          @input='nutrient_value_update'
          outlined
        )
          template(
            v-slot:label
          )
            LabelNutrient(
              :nutrient='nutrient'
            )
      TextFieldNutrient(
        nutrient='calories'
        :nutrient_value_initial='calories_fat'
        @update:nutrient_value='nutrient_value => update_fat(nutrient_value ? nutrient_value / 9 : nutrient_value)'
        v-slot='{ focused_update, nutrient, nutrient_value, nutrient_value_update }'
      )
        v-text-field(
          autocomplete='off'
          type='number'
          :value='nutrient_value'
          @blur='focused_update(false)'
          @focus='focused_update(true)'
          @input='nutrient_value_update'
          outlined
        )
          template(
            v-slot:label
          )
            LabelNutrient(
              :nutrient='nutrient'
            )
      TextFieldNutrient(
        nutrient='calories'
        :nutrient_value_initial='calories_protein'
        @update:nutrient_value='nutrient_value => update_protein(nutrient_value ? nutrient_value / 4 : nutrient_value)'
        v-slot='{ focused_update, nutrient, nutrient_value, nutrient_value_update }'
      )
        v-text-field(
          autocomplete='off'
          type='number'
          :value='nutrient_value'
          @blur='focused_update(false)'
          @focus='focused_update(true)'
          @input='nutrient_value_update'
          outlined
        )
          template(
            v-slot:label
          )
            LabelNutrient(
              :nutrient='nutrient'
            )
    v-col
      v-text-field(
        label='Calories %'
        :value='percentage_carbs'
        readonly
        filled
      )
      v-text-field(
        label='Calories %'
        :value='percentage_fat'
        readonly
        filled
      )
      v-text-field(
        label='Calories %'
        :value='percentage_protein'
        readonly
        filled
      )
  v-row
    v-col
      v-text-field(
        label='Total Calories'
        :value='calories_total'
        readonly
        filled
      )
</template>

<script>
import TextFieldNutrient from './TextFieldNutrient.vue';

import LabelNutrient from './LabelNutrient.vue';

const update_carbs = function (value)
{
  this.carbs = value || 0;

  this.$emit('update:carbs', value);

  this.$emit('update:calories_total', this.calories_total);
};

const update_fat = function (value)
{
  this.fat = value || 0;

  this.$emit('update:fat', value);

  this.$emit('update:calories_total', this.calories_total);
};

const update_protein = function (value)
{
  this.protein = value || 0;

  this.$emit('update:protein', value);

  this.$emit('update:calories_total', this.calories_total);
};

const calories_carbs = function ()
{
  return this.carbs * 4;
};

const calories_fat = function ()
{
  return this.fat * 9;
};

const calories_protein = function ()
{
  return this.protein * 4;
};

const calories_total = function ()
{
  return this.calories_carbs + this.calories_fat + this.calories_protein;
};

const percentage_carbs = function ()
{
  return this.calories_total ? window.Number(this.calories_carbs / this.calories_total * 100).toFixed(1) : 0;
};

const percentage_fat = function ()
{
  return this.calories_total ? window.Number(this.calories_fat / this.calories_total * 100).toFixed(1) : 0;
};

const percentage_protein = function ()
{
  return this.calories_total ? window.Number(this.calories_protein / this.calories_total * 100).toFixed(1) : 0;
};

const mounted = function ()
{
  this.$emit('update:calories_total_initial', this.calories_total);
};

export default
{
  components:
  {
    LabelNutrient,
    TextFieldNutrient,
  },
  computed:
  {
    calories_carbs,
    calories_fat,
    calories_protein,
    calories_total,
    percentage_carbs,
    percentage_fat,
    percentage_protein,
  },
  data()
  {
    return {
      carbs: 0,
      fat: 0,
      protein: 0,
    };
  },
  methods:
  {
    update_carbs,
    update_fat,
    update_protein,
  },
  mounted,
  props:
  {
    initial_carbs: { required: true },
    initial_fat: { required: true },
    initial_protein: { required: true },
  },
  watch:
  {
    initial_carbs:
    {
      handler()
      {
        this.carbs = this.initial_carbs || 0;
      },
      immediate: true,
    },
    initial_fat:
    {
      handler()
      {
        this.fat = this.initial_fat || 0;
      },
      immediate: true,
    },
    initial_protein:
    {
      handler()
      {
        this.protein = this.initial_protein || 0;
      },
      immediate: true,
    },
  },
}
</script>